import React, { useEffect, useState } from 'react';
import { useGlobalContext } from '../../Contexts/GlobalContext';
import TotalSurveyIcon from '../../assets/icons/TotalSurveyIcon.svg';
import TotalLiveSurveyIcon from '../../assets/icons/TotalLiveSurvey.svg';
import TotalPendingSurvey from '../../assets/icons/TotalPendingSurvey.svg';
import TotalCompleatSurvey from '../../assets/icons/TotalCompleateSurvey.svg';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { RxCross2 } from 'react-icons/rx';
import { MdOutlineModeEditOutline, MdDownload } from 'react-icons/md';
import { IoMdArchive } from 'react-icons/io';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  CustomTablePagination,
  formateZodError,
  timeDifference,
} from '../../Utlils';
import NoData from '../../components/NoData';
import { utils, writeFile } from 'xlsx';
import DeleteModal from '../../components/DeleteModal';
import { CircularProgress } from '@mui/material';
import Required from '../../components/Required';
import { getValueByCountryRateAndLOI } from './surveyDetails/components/helperData';
import SurveyTableLoader from './surveyDetails/components/SurveyTableLoader';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { FaCheck } from 'react-icons/fa';
import {
  addNewSurvey,
  archiveSurvey,
  editSurveyAction,
  getAllSurveyStats,
  getSurveyCount,
} from './surveyActions';
import { calculateValue } from '../Feasibility/CalcHelper';
import PageWrapper from '../../components/PageWrapper';
import SearchableCountrySelect from '../../components/SearchableCountrySelect';
import AISurveyModal from './components/AISurveyModal';
import { RiArrowRightSLine, RiCheckLine } from 'react-icons/ri';
import { createDraftSchema } from '../qualitative-surveys/qualSurveyValidators';
import { createQualDraftSurvey } from '../qualitative-surveys/qualSurveysActions';
import QualitativeTab from './components/QualitativeTab';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 700,
  maxWidth: '90vw',
  maxHeight: '90vh',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 8,
  overflow: 'hidden',
};

let dummyfilterData = [
  'All',
  'Live',
  'Awarded',
  'Paused',
  'Completed',
  'billed',
  'Archived',
];

const Survey = () => {
  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState(
    localStorage.getItem('survey-tab') ? localStorage.getItem('survey-tab') : 1,
  );
  const {
    teamMembers,
    countryData,
    user,
    setSnackbar,
    allSurveyGroup,
    getAllSurveyGroup,
    industryData,
    studyTypesData,
    organization,
  } = useGlobalContext();
  const initialMainTabState = JSON.parse(localStorage.getItem('mainTab'));
  const [mainTab, setMainTab] = useState(
    initialMainTabState && [1, 2]?.includes(initialMainTabState)
      ? initialMainTabState
      : 1,
  );
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [filters, setFilters] = useState({});
  const [debouncedSurveySearchText, setDebouncedSurveySearchText] = useState(
    filters?.search || '',
  );
  // fetch surveyStats
  const {
    data: allSurveyStats,
    isLoading: allSurveyStatsLoading,
    isError: allSurveyStatsError,
    refetch,
  } = useQuery({
    queryKey: [
      'allSurveyStatus',
      organization?.id,
      undefined,
      tab,
      page,
      rowsPerPage,
      filters?.industry,
      filters?.projectManager,
      filters?.studyType,
      filters?.country,
      debouncedSurveySearchText,
    ],
    queryFn: () =>
      getAllSurveyStats(
        organization?.id,
        undefined,
        dummyfilterData?.[tab]?.toLowerCase(),
        page,
        rowsPerPage,
        filters?.industry,
        filters?.projectManager,
        filters?.studyType,
        filters?.country,
        debouncedSurveySearchText,
      ),
    enabled: Boolean(mainTab === 1 && organization?.id),
    staleTime: 10000,
    cacheTime: 15000,
  });
  const { mutateAsync: refetchSurveys } = useMutation({
    mutationFn: () =>
      getAllSurveyStats(
        organization?.id,
        'remove',
        dummyfilterData?.[tab]?.toLowerCase(),
        page,
        rowsPerPage,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries([
        'allSurveyStatus',
        organization?.id,
        'remove',
        dummyfilterData?.[tab]?.toLowerCase(),
        page,
        rowsPerPage,
      ]);
    },
  });
  const handleSurveyStatsRefresh = () => {
    refetchSurveys();
  };
  // fetch survey statuses count
  const {
    data: surveyStatusesCount,
    isLoading: surveyStatusesCountLoading,
    isError: surveyStatusesCountError,
  } = useQuery({
    queryFn: () => getSurveyCount(organization?.id),
    // enabled: Boolean(mainTab === 1 && organization?.id),
    queryKey: ['surveyCounts', organization?.id],
    staleTime: 10000,
    cacheTime: 15000,
  });
  // mutate the survey statuses count when survey gets archived
  const { mutateAsync: mutateSurveyCounts } = useMutation({
    mutationFn: archiveSurvey,
    onSuccess: () => {
      queryClient.invalidateQueries(['surveyCounts', organization?.id]);
    },
  });
  // mutate after creating new survey
  const { mutateAsync: addSurveyMutation } = useMutation({
    mutationFn: ({ inputData, user }) => addNewSurvey(inputData, user),
    onSuccess: () => {
      queryClient.invalidateQueries(['surveyCounts', organization?.id]);
    },
  });

  const [selectRows, setSelectRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [quantQualModal, setQuantQualModal] = useState(false);
  const [surveyTypeModal, setSurveyTypeModal] = useState(false);
  const [qualProjectModal, setQualProjectModal] = useState(false);
  const [qualProjectData, setQualProjectData] = useState({});
  const [qualFormErrors, setQualFormErrors] = useState({});
  const [aiSurveyModal, setAISurveyModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const handleOpen = () => setOpen(true);
  const [inputData, setInputData] = useState({
    edit: false,
    setup: {
      targetAudience: 'B2C',
    },
    isInstantSampling: true, // Permanently selected by default
  });

  // get all survey stats

  // Archive SURVEYS:
  const deleteSurveys = async (e) => {
    e.preventDefault();
    try {
      setTab(6);
      await mutateSurveyCounts(selectRows);
      handleSurveyStatsRefresh();
      setSelectRows([]);
      setSnackbar((prev) => ({
        open: true,
        msg: 'Survey Archived Successfully!',
        severity: 'success',
      }));
    } catch (error) {
      setSnackbar((prev) => ({
        open: true,
        msg: 'Something went wrong!',
        severity: 'error',
      }));
    } finally {
      setDeleteModal(false);
    }
  };

  const handleCloseModal = (e) => setDeleteModal(false);
  function validateCPI(cpi) {
    {
      const minCPI = inputData?.setup?.targetAudience === 'B2B' ? 5 : 1;
      const value = Number(cpi);

      if (value < minCPI) {
        setSnackbar({
          msg: `Survey CPI should be at least $${minCPI} USD for ${inputData?.setup?.targetAudience === 'B2B' ? 'B2B' : 'B2C'} surveys`,
          open: true,
          severity: 'error',
        });
        return false;
      }

      if (value >= 499) {
        setSnackbar({
          msg: 'Survey CPI should be less than or equal to 499',
          open: true,
          severity: 'error',
        });
        return false;
      }
      return true;
    }
  }
  // HANDLE CHANGE:
  const handleChange = (e) => {
    let { name, value } = e.target;
    setInputData((prev) => ({ ...prev, [name]: value }));
  };
  //ADD SURVEY & SURVEY GROUP:
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const validation = validateCPI(inputData?.setup?.surveyCpi);
      if (!validation) {
        setLoading(false);
        return;
      }
      await addSurveyMutation({ inputData, user });
      handleSurveyStatsRefresh();
      queryClient.invalidateQueries([
        'allSurveyStatus',
        organization?.id,
        'remove',
        'awarded',
        page,
        rowsPerPage,
      ]);
      await getAllSurveyGroup();
      setInputData({
        edit: false,
        setup: {
          targetAudience: 'B2C',
        },
        isInstantSampling: true, // Reset to true after creation
      });
      setLoading(false);
      setOpen(false);
      setSnackbar((prev) => ({
        open: true,
        msg: 'Survey Created Successfully !',
        severity: 'success',
      }));
    } catch (error) {
      setLoading(false);
      setOpen(false);
      setSnackbar((prev) => ({
        open: true,
        msg: 'Something went wrong!',
        severity: 'error',
      }));
    }
  };
  // console.log(name);

  //EDIT SURVEY & SURVEY GROUP:
  const editSurvey = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      const validation = validateCPI(inputData?.setup?.surveyCpi);
      if (!validation) {
        setLoading(false);
        return;
      }

      await editSurveyAction(inputData);
      handleSurveyStatsRefresh();
      setSnackbar((prev) => ({
        open: true,
        msg: 'Survey Details Updated Successfully !',
        severity: 'success',
      }));
      setOpen(false);
      setLoading(false);
      setInputData({
        edit: false,
        setup: {
          targetAudience: 'B2C',
        },
        isInstantSampling: true,
      });
    } catch (error) {
      setSnackbar((prev) => ({
        open: true,
        msg: 'Something went wrong !',
        severity: 'error',
      }));
      setOpen(false);
      setLoading(false);
      setInputData({
        edit: false,
        setup: {
          targetAudience: 'B2C',
        },
        isInstantSampling: true,
      });
      // console.log(error);
    } finally {
      setSelectRows([]);
    }
  };

  //HANDLE FILTER CHANGE DATA:
  const handelFilterChange = (e) => {
    let { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  //GENERATE EXCEL FILE:
  const [xlData, setXlData] = useState([]);
  const generateExcelFile = (orgData) => {
    let generateData = [];
    orgData?.forEach((data) => {
      const surveyStats = allSurveyStats?.data?.find(
        (stats) => stats?.survey?._id == data?._id,
      );
      generateData.push({
        'Survey Name': data?.surveyName,
        'Project Number': data?.projectNumber,
        'Survey Number': data?.surveyNumber,
        'Progress/completes': `${surveyStats?.completes}/${data?.expectedMatrix?.expectedCompletes}`,
        'Avg. LOI': `${
          surveyStats?.avgLoi ? surveyStats?.avgLoi + 'min' : '0 min'
        }`,
        'Conversation Rate': `${
          surveyStats?.conversion ? surveyStats?.conversion + '%' : ' 0 %'
        } `,
        'Incidence Rate': `${surveyStats?.IR ? `${surveyStats?.IR} %` : `0 %`}`,
        'Avg. CPI': `${surveyStats?.avgCPI || 0}`,
        'Drop-off': `${
          surveyStats?.dropRate ? `${surveyStats?.dropRate} %` : `0 `
        }`,
        EPC: `${Number(surveyStats?.epc) || 0}`,
      });
    });
    setXlData(generateData);
  };
  const location = useLocation();

  // Check if navigated from dashboard with openCreateModal state
  useEffect(() => {
    if (location.state?.openCreateModal) {
      setSurveyTypeModal(true);
      // Clear the state to prevent modal from reopening on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (page != 0) {
        setPage(0);
      }
      setDebouncedSurveySearchText(filters?.search);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [filters?.search]);
  useEffect(() => {
    setInputData((prev) => ({
      ...prev,
      peoples: { projectManager: [user?._id] },
    }));
    if (selectRows?.length) {
      generateExcelFile(selectRows);
    } else {
      generateExcelFile(allSurveyStats?.data?.map((d) => d?.survey));
    }
  }, [allSurveyStats?.data?.length, selectRows?.length]);
  useEffect(() => {
    if (
      inputData?.expectedMatrix?.expectedCompletionLOI &&
      inputData?.expectedMatrix?.expectedIncidenceRate &&
      inputData?.setup?.country &&
      inputData?.setup?.targetAudience
    ) {
      setInputData((prev) => ({
        ...prev,
        setup: {
          ...prev.setup,
          surveyCpi: Number(
            getValueByCountryRateAndLOI(
              inputData?.setup?.country,
              inputData?.expectedMatrix?.expectedIncidenceRate,
              inputData?.expectedMatrix?.expectedCompletionLOI,
              inputData?.setup?.targetAudience,
            ) * 1.5,
          )?.toFixed(2),
          // surveyCpi: calculateValue(
          //   inputData?.setup?.country,
          //   inputData?.expectedMatrix?.expectedCompletionLOI,
          //   inputData?.expectedMatrix?.expectedIncidenceRate,
          //   inputData?.setup?.targetAudience == "B2C" ? 1 : 2
          // ),
        },
      }));
    }
  }, [
    inputData?.expectedMatrix?.expectedCompletionLOI,
    inputData?.expectedMatrix?.expectedIncidenceRate,
    inputData?.setup?.country,
  ]);
  //DOWNLOAD TO EXCEL DATA:
  const DownloadToExcel = () => {
    var wb = utils.book_new(),
      ws = utils.json_to_sheet(xlData);
    utils.book_append_sheet(wb, ws, 'Sheet1');
    setSelectRows([]);
    writeFile(wb, `Survey-Data.xlsx`);
    setSnackbar({
      open: true,
      severity: 'success',
      msg: 'Excel Sheet Downloaded!',
    });
  };

  // pagination function
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const hoverColorMap = {
    violet: 'hover:bg-violet-200',
    rose: 'hover:bg-rose-200',
  };
  const ColorMap = {
    violet: 'bg-violet-400',
    rose: 'bg-rose-400',
  };
  const orderTypes = [
    {
      label: 'Quantitative',
      value: 1,
      imagePath: '/assets/quantitative-type-image.svg',
      hoverColor: 'rose',
      borderColor: 'border-rose-500',
      checkBorderColor: 'border-rose-600',
      comingSoon: false,
    },
    {
      label: 'Qualitative',
      value: 2,
      imagePath: '/assets/qualitative-type-image.svg',
      hoverColor: 'violet',
      borderColor: 'border-violet-600',
      checkBorderColor: 'border-violet-700',
      comingSoon: true,
    },
  ];

  const handleQualCloseModal = () => {
    setQualProjectModal(false);
    setQualProjectData({});
    setQualFormErrors({});
  };
  const qualHandleChange = (e) => {
    const { name, value } = e.target;
    if (qualFormErrors?.projectInfo || qualFormErrors[name]) {
      setQualFormErrors((prev) => ({
        ...prev,
        projectInfo: '',
        [name || '']: '',
      }));
    }

    setQualProjectData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleQualProjectSubmit = async (e) => {
    e?.preventDefault();
    try {
      const dataToValidate = {
        projectInfo: qualProjectData,
        organization: user?.organization?._id,
      };
      const validationResult = createDraftSchema.safeParse(dataToValidate);
      if (validationResult.success) {
        // console.log("success validationResult=>", validationResult);
        const res = await createQualDraftSurvey(validationResult?.data);
        // console.log("res=>", res);

        if (!res?.success) {
          throw new Error(res?.message || 'Unable to create draft !');
        }
        queryClient.invalidateQueries({
          queryKey: ['qualitative-projects'],
        });
        setSnackbar({
          open: true,
          severity: 'success',
          msg: 'Qualitative Survey Draft Created Successfully',
        });

        setQualProjectModal(false);
        setQualProjectData({});
        setQualFormErrors({});
      } else {
        const formattedErrors = formateZodError(validationResult);
        console.log('formattedErrors=>', formattedErrors);
        setQualFormErrors(formattedErrors);
      }
    } catch (error) {
      setSnackbar({
        open: true,
        severity: 'error',
        msg: error?.message || 'Unable to create draft !',
      });
    }
  };
  // console.log('inputData=>', inputData);
  // console.log("user=>", user);
  // console.log("allSurveyStats=>", allSurveyStats);
  // console.log('surveyStatusesCount=>', surveyStatusesCount);
  // console.log("filters=>", filters);
  // console.log("selectRows=>", selectRows);
  return (
    <PageWrapper>
      <div className="w-full flex flex-col gap-6 py-6">
        {/* Header */}
        <div className="w-full flex flex-col md:flex-row md:items-center justify-between gap-4 md:gap-0">
          {/* Text Content */}
          <div>
            <h1 className="text-[#0226BE] text-[24px] md:text-[28px] font-[500] mb-1">
              Surveys
            </h1>
            <p className="text-[#666] text-[13px] md:text-[14px] font-[400]">
              Manage and track all your survey projects
            </p>
          </div>

          {/* Buttons Container */}
          <div className="flex flex-wrap items-center gap-3">
            <button
              type="button"
              className="flex-1 md:flex-none flex items-center justify-center gap-2 bg-white border border-[#E0E0E0] hover:border-[#0226BE]/50 text-[#333] px-3 md:px-4 py-2.5 text-[14px] font-[500] rounded-md hover:bg-[#F8F9FF] transition-all whitespace-nowrap"
              onClick={() => navigate('/profile/redirects-and-keys')}
              title="Configure redirect endpoints and secret key"
            >
              <svg
                className="w-4 h-4 text-[#0226BE] shrink-0"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"
                />
              </svg>
              Redirects setup
            </button>
            <button
              className="flex-1 md:flex-none group flex items-center justify-center gap-2 bg-white border border-[#E0E0E0] hover:border-[#0226BE]/50 text-[#333] px-3 md:px-4 py-2.5 text-[14px] font-[500] rounded-md hover:bg-[#F8F9FF] transition-all"
              onClick={() => setAISurveyModal(true)}
            >
              <svg
                className="w-4 h-4 text-[#0226BE]"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z"
                />
              </svg>
              <span className="whitespace-nowrap">Create with AI</span>
              <span className="px-1.5 py-0.5 text-[9px] font-[600] bg-[#0226BE] text-white rounded">
                NEW
              </span>
            </button>

            <button
              className="flex-1 md:flex-none bg-[#0226BE] text-white px-4 md:px-6 py-2.5 text-[14px] font-[500] rounded-md hover:bg-[#021ea8] transition-colors whitespace-nowrap"
              onClick={(e) => setQuantQualModal(true)}
              // onClick={(e) => setSurveyTypeModal(true)}
            >
              Create Survey
            </button>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {/* Total Surveys */}
          <div className="bg-white border border-[#E0E0E0] rounded-md py-4 px-5 flex flex-col gap-2 hover:border-[#0226BE]/30 transition-colors">
            <div className="w-10 h-10 rounded-md bg-blue-50 flex items-center justify-center">
              <img src={TotalSurveyIcon} alt="" className="w-5 h-5" />
            </div>
            <h3 className="text-[#1a1a1a] font-[600] text-[20px] md:text-[22px]">
              {surveyStatusesCount?.all || 0}
            </h3>
            <p className="text-[#666] text-[13px] font-[400]">Total Surveys</p>
          </div>

          {/* Live Surveys */}
          <div className="bg-white border border-[#E0E0E0] rounded-md py-4 px-5 flex flex-col gap-2 hover:border-[#0226BE]/30 transition-colors">
            <div className="w-10 h-10 rounded-md bg-green-50 flex items-center justify-center">
              <img src={TotalLiveSurveyIcon} alt="" className="w-5 h-5" />
            </div>
            <h3 className="text-[#1a1a1a] font-[600] text-[20px] md:text-[22px]">
              {surveyStatusesCount?.live || 0}
            </h3>
            <p className="text-[#666] text-[13px] font-[400]">Live Surveys</p>
          </div>

          {/* Completed */}
          <div className="bg-white border border-[#E0E0E0] rounded-md py-4 px-5 flex flex-col gap-2 hover:border-[#0226BE]/30 transition-colors">
            <div className="w-10 h-10 rounded-md bg-purple-50 flex items-center justify-center">
              <img src={TotalCompleatSurvey} alt="" className="w-5 h-5" />
            </div>
            <h3 className="text-[#1a1a1a] font-[600] text-[20px] md:text-[22px]">
              {surveyStatusesCount?.completed || 0}
            </h3>
            <p className="text-[#666] text-[13px] font-[400]">
              Completed Surveys
            </p>
          </div>

          {/* Paused */}
          <div className="bg-white border border-[#E0E0E0] rounded-md py-4 px-5 flex flex-col gap-2 hover:border-[#0226BE]/30 transition-colors">
            <div className="w-10 h-10 rounded-md bg-orange-50 flex items-center justify-center">
              <img src={TotalPendingSurvey} alt="" className="w-5 h-5" />
            </div>
            <h3 className="text-[#1a1a1a] font-[600] text-[20px] md:text-[22px]">
              {surveyStatusesCount?.paused || 0}
            </h3>
            <p className="text-[#666] text-[13px] font-[400]">Paused Surveys</p>
          </div>

          {/* billed */}
          <div className="bg-white border border-[#E0E0E0] rounded-md py-4 px-5 flex flex-col gap-2 hover:border-[#0226BE]/30 transition-colors">
            <div className="w-10 h-10 rounded-md bg-gray-50 flex items-center justify-center">
              <img
                src={TotalSurveyIcon}
                alt=""
                className="w-5 h-5 opacity-50"
              />
            </div>
            <h3 className="text-[#1a1a1a] font-[600] text-[20px] md:text-[22px]">
              {surveyStatusesCount?.billed || 0}
            </h3>
            <p className="text-[#666] text-[13px] font-[400]">Billed Surveys</p>
          </div>
        </div>
        {/* main tab container */}
        <div className="bg-gray-100 py-2 px-3 flex items-center gap-2 border rounded-sm">
          {['Quantitative', 'Qualitative']?.map((item, index) => (
            <h1
              className={`p-2 rounded-md cursor-pointer ${mainTab === index + 1 ? ' bg-white border-2 border-primary text-primary shadow-sm font-semibold' : ' '}`}
              onClick={() => {
                setMainTab(index + 1);
                localStorage.setItem('mainTab', index + 1);
              }}
            >
              {item}
            </h1>
          ))}
        </div>
        {mainTab === 1 ? (
          <>
            {/* Filters Section */}
            <div className="w-full bg-white border border-[#E0E0E0] rounded-md p-4 flex flex-col lg:flex-row lg:items-center justify-between gap-4">
              {/* Left: Filters Section */}
              <div className="flex flex-wrap items-center gap-1 flex-1">
                {/* Industry Select */}
                <select
                  className="border border-gray-300 rounded-md py-2.5 px-4 text-[#333] text-[14px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all duration-200 appearance-none cursor-pointer hover:border-gray-400 bg-white sm:max-w-[200px] h-[48px]"
                  onChange={handelFilterChange}
                  value={filters?.industry || ''}
                  name="industry"
                  style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23333' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right 12px center',
                    backgroundSize: '12px',
                  }}
                >
                  <option value="">Industry Type</option>
                  {industryData?.map((data, key) => (
                    <option key={key} value={data?.value}>
                      {data?.label}
                    </option>
                  ))}
                </select>

                {/* Project Manager Select */}
                <select
                  className="border border-gray-300 rounded-md py-2.5 px-4 text-[#333] text-[14px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all duration-200 appearance-none cursor-pointer hover:border-gray-400 bg-white sm:w-[200px] h-[48px]"
                  onChange={handelFilterChange}
                  value={filters?.projectManager || ''}
                  name="projectManager"
                  style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23333' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right 12px center',
                    backgroundSize: '12px',
                  }}
                >
                  <option value="">Project Manager</option>
                  {teamMembers?.map((data, key) => (
                    <option value={data?._id} key={key}>
                      {data?.personalDetails?.fullName}
                    </option>
                  ))}
                </select>

                {/* Study Type Select */}
                <select
                  className="border border-gray-300 rounded-md py-2.5 px-4 text-[#333] text-[14px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all duration-200 appearance-none cursor-pointer hover:border-gray-400 bg-white sm:max-w-[200px] h-[48px]"
                  onChange={handelFilterChange}
                  name="studyType"
                  value={filters?.studyType || ''}
                  style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23333' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right 12px center',
                    backgroundSize: '12px',
                  }}
                >
                  <option value="">Study Type</option>
                  {studyTypesData?.map((data, ind) => (
                    <option value={data?.value} key={ind}>
                      {data?.label}
                    </option>
                  ))}
                </select>

                {/* Country Select */}
                <select
                  className="border border-gray-300 rounded-md py-2.5 px-4 text-[#333] text-[14px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all duration-200 appearance-none cursor-pointer hover:border-gray-400 bg-white   sm:max-w-[200px] h-[48px] "
                  onChange={handelFilterChange}
                  value={filters?.country || ''}
                  name="country"
                  style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23333' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right 12px center',
                    backgroundSize: '12px',
                  }}
                >
                  <option value="">Select Country</option>
                  {countryData?.isLoading ? (
                    <option value="" disabled>
                      Loading Countries...
                    </option>
                  ) : countryData?.error ? (
                    <option value="" disabled>
                      Error loading countries
                    </option>
                  ) : (
                    countryData?.data?.map((data, key) => (
                      <option value={data?.name} key={key}>
                        {data?.name}
                      </option>
                    ))
                  )}
                </select>

                {/* Clear Filters Link */}
                {(filters?.industry ||
                  filters?.projectManager ||
                  filters?.studyType ||
                  filters?.country) && (
                  <button
                    type="button"
                    className="text-[#0226BE] text-[14px] font-[500] hover:underline transition-all w-full sm:w-auto py-2"
                    onClick={() => setFilters({})}
                  >
                    Clear filters
                  </button>
                )}
              </div>

              {/* Right: Search Section */}
              <div className="w-full lg:w-auto lg:min-w-[350px]">
                <div className="relative w-full">
                  <input
                    type="text"
                    className="w-full border border-gray-300 rounded-md py-2.5 pl-4 pr-4 text-[#1a1a1a] text-[14px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all duration-200 placeholder:text-gray-400 hover:border-gray-400 h-[48px]"
                    name="search"
                    value={filters?.search || ''}
                    onChange={handelFilterChange}
                    placeholder="Search by name, survey number..."
                  />
                </div>
              </div>
            </div>
            {/* Tabs and Table */}
            <div className="w-full bg-white border border-[#E0E0E0] rounded-md overflow-hidden">
              {/* Tabs */}
              <div className="w-full bg-white">
                <div className="w-full flex items-center gap-4 md:gap-8 px-4 md:px-6 py-3 border-b border-[#E0E0E0] overflow-x-auto no-scrollbar transition-all">
                  {dummyfilterData?.map((data, ind) => (
                    <button
                      key={ind}
                      type="button"
                      className={`text-[13px] md:text-[14px] font-[500] cursor-pointer transition-all pb-2 border-b-2 whitespace-nowrap capitalize flex-shrink-0 ${
                        tab == ind
                          ? `text-[#0226BE] font-[600] border-[#0226BE]`
                          : `text-[#666] border-transparent hover:text-[#0226BE] hover:border-[#0226BE]/30`
                      }`}
                      onClick={(e) => {
                        setTab(ind);
                        setSelectRows([]);
                        setPage(0);
                        localStorage.setItem('survey-tab', ind);
                      }}
                    >
                      {data}
                      <span
                        className={`ml-1 opacity-70 ${tab == ind ? 'font-[600]' : 'font-[400]'}`}
                      >
                        (
                        {ind == 0
                          ? surveyStatusesCount?.all || 0
                          : surveyStatusesCount?.[data?.toLowerCase()] || 0}
                        )
                      </span>
                    </button>
                  ))}
                </div>
              </div>
              {/* Actions Bar */}
              <div className="w-full flex items-center justify-between px-6 py-4 border-b border-[#E0E0E0] bg-gray-50">
                <div className="flex items-center gap-4">
                  <input
                    type="checkbox"
                    className="w-4 h-4 border-2 border-gray-300 text-[#0226BE] focus:ring-2 focus:ring-[#0226BE] rounded cursor-pointer"
                    checked={selectRows?.length > 0}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectRows(
                          allSurveyStats?.data?.map((d) => d?.survey),
                        );
                      } else {
                        setSelectRows([]);
                      }
                    }}
                  />
                  {selectRows?.length > 0 && (
                    <span className="text-[14px] text-[#0226BE] font-[500]">
                      {selectRows?.length} selected
                    </span>
                  )}
                </div>
                {selectRows?.length > 0 && (
                  <div className="flex items-center gap-3">
                    {selectRows?.length === 1 && (
                      <button
                        type="button"
                        onClick={(e) => {
                          setOpen(true);
                          setInputData({
                            edit: true,
                            setup: {
                              targetAudience: 'B2C',
                            },
                            isInstantSampling:
                              selectRows?.[0]?.DIY_SurveyType === 1
                                ? true
                                : true,
                            ...selectRows?.[0],
                          });
                        }}
                        className="p-2 hover:bg-gray-100 rounded-md transition-colors"
                        title="Edit Survey"
                      >
                        <MdOutlineModeEditOutline
                          size={20}
                          className="text-[#0226BE]"
                        />
                      </button>
                    )}
                    <button
                      type="button"
                      onClick={(e) => DownloadToExcel()}
                      className="p-2 hover:bg-gray-100 rounded-md transition-colors"
                      title="Download Excel"
                    >
                      <MdDownload size={20} className="text-[#666]" />
                    </button>
                    <button
                      type="button"
                      className="p-2 hover:bg-gray-100 rounded-md transition-colors"
                      title="Archive Surveys"
                      onClick={(e) => {
                        if (selectRows?.length) {
                          let nonArchiveSurveys = selectRows?.filter(
                            (d) =>
                              d?.surveyStatus !== 'archived' &&
                              d?.surveyStatus !== 'completed' &&
                              d?.surveyStatus !== 'billed',
                          );
                          if (nonArchiveSurveys.length) {
                            setDeleteModal(true);
                          } else {
                            setSnackbar((prev) => ({
                              open: true,
                              msg: "Already Archived, Billed and Completed surveys can't be archived !",
                              severity: 'warning',
                            }));
                          }
                        } else {
                          setSnackbar((prev) => ({
                            open: true,
                            msg: 'Please Select at least one survey to Archive!',
                            severity: 'warning',
                          }));
                        }
                      }}
                    >
                      <IoMdArchive size={20} className="text-[#666]" />
                    </button>
                  </div>
                )}
              </div>

              {/* Table */}
              <div className="w-full flex flex-col">
                {allSurveyStatsLoading ? (
                  <SurveyTableLoader />
                ) : allSurveyStatsError ? (
                  <div className=" h-[200px] flex items-center justify-center">
                    <h1 className="text-[#666666]">Something went wrong </h1>
                  </div>
                ) : allSurveyStats?.data?.noData ? (
                  <NoData />
                ) : (
                  <div className="w-full overflow-x-auto containerScroll">
                    <table
                      className="whitespace-nowrap text-left w-full"
                      id="table-to-xls-DATA"
                    >
                      <thead className="h-[50px] bg-gray-50 border-b border-[#E0E0E0]">
                        <tr>
                          <th className="text-[#666] text-[13px] font-[500] px-4 text-start w-[40px]"></th>
                          <th className="text-[#666] text-[13px] font-[500] px-4 text-start min-w-[250px]">
                            Survey Name/ Survey Number/ Project Number
                          </th>
                          <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                            Progress
                          </th>
                          <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                            Survey CPI
                          </th>
                          <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                            Avg. LOI
                          </th>
                          <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                            Conversion Rate
                          </th>
                          <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                            Incidence Rate
                          </th>
                          <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                            Avg. CPI
                          </th>
                          <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                            Drop-off
                          </th>
                          <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                            EPC
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {allSurveyStats?.data?.length == 0 ? (
                          <td colSpan={9}>
                            <div className="py-10">
                              <NoData />
                            </div>
                          </td>
                        ) : (
                          allSurveyStats?.data?.map((data, ind) => {
                            return (
                              <tr
                                key={ind}
                                className="border-b border-[#E0E0E0] transition-colors cursor-pointer hover:bg-blue-50/30"
                                onClick={(e) => {
                                  navigate(`${data?.survey?._id}/details`);
                                }}
                              >
                                <td
                                  className="px-4 py-3"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <input
                                    type="checkbox"
                                    className="w-4 h-4 border-2 border-gray-300 text-[#0226BE] focus:ring-2 focus:ring-[#0226BE] rounded cursor-pointer"
                                    checked={selectRows?.some(
                                      (se) => se?._id == data?.survey?._id,
                                    )}
                                    onChange={(e) => {
                                      e.stopPropagation();
                                      if (e.target.checked) {
                                        setSelectRows((prev) => [
                                          ...prev,
                                          data?.survey,
                                        ]);
                                      } else {
                                        setSelectRows(
                                          selectRows?.filter(
                                            (sc) =>
                                              sc?._id !== data?.survey?._id,
                                          ),
                                        );
                                      }
                                    }}
                                  />
                                </td>
                                <td className="px-4 py-3">
                                  <div className="flex flex-col gap-2">
                                    <div className="flex items-center gap-2 flex-wrap">
                                      <h2 className="text-[#0226BE] font-[500] text-[13px] max-w-[300px] overflow-hidden text-ellipsis hover:text-[#021ea8] transition-colors">
                                        {data?.survey?.surveyName}
                                      </h2>
                                      {data?.survey?.DIY_SurveyType === 1 && (
                                        <span className="inline-flex items-center gap-1 bg-gradient-to-r from-amber-50 to-orange-50 text-orange-600 font-[600] px-2 py-0.5 text-[10px] border border-orange-300 rounded-full">
                                          <svg
                                            className="w-3 h-3 fill-current"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z" />
                                          </svg>
                                          <span className="whitespace-nowrap">
                                            Instant
                                          </span>
                                        </span>
                                      )}
                                      {data?.survey?.setup?.country && (
                                        <span className="bg-blue-50 text-[#0226BE] font-[500] px-2 py-0.5 text-[10px] border border-blue-200 rounded-md">
                                          {data?.survey?.setup?.country}
                                        </span>
                                      )}
                                    </div>
                                    <div className="flex flex-col gap-1">
                                      <div className="flex items-center gap-2 flex-wrap">
                                        <span
                                          className={`text-[#666] font-[400] text-[12px] ${
                                            String(
                                              data?.survey?.projectNumber,
                                            )?.includes(
                                              debouncedSurveySearchText?.trim(),
                                            ) &&
                                            debouncedSurveySearchText?.trim()
                                              ?.length
                                              ? 'bg-yellow-200 px-1 rounded'
                                              : ''
                                          }`}
                                        >
                                          PN#{data?.survey?.projectNumber}
                                        </span>
                                        <span
                                          className={`text-[#666] font-[400] text-[12px] ${
                                            String(
                                              data?.survey?.surveyNumber,
                                            )?.includes(
                                              debouncedSurveySearchText?.trim(),
                                            ) &&
                                            debouncedSurveySearchText?.trim()
                                              ?.length
                                              ? 'bg-yellow-200 px-1 rounded'
                                              : ''
                                          }`}
                                        >
                                          SN#{data?.survey?.surveyNumber}
                                        </span>
                                        {data?.survey?.surveyStatus ==
                                          'billed' && (
                                          <span
                                            className={`${
                                              data?.invoiceStatus !== 'Invoiced'
                                                ? 'bg-gray-100 text-gray-700 font-[500]'
                                                : 'bg-[#333] text-white font-[500]'
                                            } py-0.5 px-2 text-[10px] rounded-full`}
                                          >
                                            {data?.invoiceStatus}
                                          </span>
                                        )}
                                      </div>
                                      {data?.lastComplete && (
                                        <p className="text-[#666] font-[400] text-[11px]">
                                          Last Complete{' '}
                                          {timeDifference(
                                            new Date(
                                              data?.lastComplete,
                                            )?.getTime(),
                                          )}{' '}
                                          ago
                                        </p>
                                      )}
                                      {data?.surveyStatus == 'completed' &&
                                        data?.reconciliationStatus && (
                                          <div className="mt-2">
                                            <span
                                              className={`text-[11px] font-[500] px-2 py-0.5 rounded-full ${
                                                data?.reconciliationStatus ==
                                                'Reconciled'
                                                  ? 'bg-green-100 text-green-700 border border-green-200'
                                                  : data?.reconciliationStatus ==
                                                      'Partially-Reconciled'
                                                    ? 'bg-orange-100 text-orange-700 border border-orange-200'
                                                    : 'bg-cyan-100 text-cyan-700 border border-cyan-200'
                                              }`}
                                            >
                                              {data?.reconciliationStatus}
                                            </span>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                </td>
                                <td className="px-4 py-3">
                                  <div className="flex items-center gap-3 min-w-[150px]">
                                    <div className="flex-1">
                                      <div className="bg-gray-200 w-full h-2 rounded-full overflow-hidden">
                                        <div
                                          className="bg-[#0226BE] h-full rounded-full transition-all"
                                          style={{
                                            width:
                                              (
                                                (+data?.completes /
                                                  +data?.survey?.expectedMatrix
                                                    ?.expectedCompletes) *
                                                100
                                              )?.toFixed(2) + '%' || '0%',
                                          }}
                                        ></div>
                                      </div>
                                    </div>
                                    <span className="text-[#333] font-[400] text-[13px] whitespace-nowrap">
                                      {data?.completes || 0} /{' '}
                                      {data?.survey?.expectedMatrix
                                        ?.expectedCompletes || 0}
                                    </span>
                                  </div>
                                </td>
                                <td className="px-4 py-3 text-[#333] font-[400] text-[13px]">
                                  ${data?.survey?.setup?.surveyCpi || 0}
                                </td>
                                <td className="px-4 py-3 text-[#333] font-[400] text-[13px]">
                                  {data?.avgLoi
                                    ? `${data?.avgLoi} min`
                                    : '0 min'}
                                </td>
                                <td className="px-4 py-3 text-[#333] font-[400] text-[13px]">
                                  {data?.conversion
                                    ? `${Number(data?.conversion)?.toFixed(2)}%`
                                    : '0%'}
                                </td>
                                <td className="px-4 py-3 text-[#333] font-[400] text-[13px]">
                                  {data?.IR
                                    ? `${Number(data?.IR)?.toFixed(2)}%`
                                    : '0%'}
                                </td>
                                <td className="px-4 py-3 text-[#333] font-[400] text-[13px]">
                                  ${data?.avgCPI || 0}
                                </td>
                                <td className="px-4 py-3">
                                  <span
                                    className={`${
                                      data?.dropRate >= 25
                                        ? 'text-red-600'
                                        : 'text-[#333]'
                                    } font-[500] text-[13px]`}
                                  >
                                    {data?.dropRate
                                      ? `${data?.dropRate}%`
                                      : '0%'}
                                  </span>
                                </td>
                                <td className="px-4 py-3">
                                  <span
                                    className={`${
                                      data?.epc <= 0.25
                                        ? 'text-red-600'
                                        : 'text-[#333]'
                                    } font-[500] text-[13px]`}
                                  >
                                    ${Number(data?.epc)?.toFixed(2) || '0.00'}
                                  </span>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
                <CustomTablePagination
                  rowsPerPageOptions={[5, 10, 25, 50, 75, 100]}
                  sx={{ fontSize: '10px' }}
                  count={allSurveyStats?.pagination?.totalRecords || 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  componentsProps={{
                    select: {
                      'aria-label': 'rows per page',
                    },
                    actions: {
                      showFirstButton: true,
                      showLastButton: true,
                    },
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </div>
            </div>
          </>
        ) : (
          <QualitativeTab />
        )}

        {/* quant qual select model */}
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={quantQualModal}
          onClose={() => {
            setQuantQualModal(false);
          }}
          closeAfterTransition
        >
          <Fade in={quantQualModal}>
            <Box
              sx={{
                ...style,
                width: 580,
                boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
              }}
            >
              <div className="px-6 py-5">
                <div className="space-y-5">
                  <div className="text-center">
                    <h1 className="text-[#333] font-[600] text-[18px]">
                      Create New Survey
                    </h1>
                    <p className="text-[13px] text-[#666] mt-1">
                      Choose between quantitative and qualitative survey types
                    </p>
                  </div>
                  <div className="flex justify-between gap-2 items-center">
                    {orderTypes.map((d, i) => {
                      // const isSelected = surveyType === d.value;
                      const isSelected = false;

                      const card = (
                        <div
                          key={i}
                          onClick={() => {
                            setQuantQualModal(false);
                            if (d.value === 1) {
                              setSurveyTypeModal(true);
                            } else {
                              setQualProjectModal(true);
                            }
                          }}
                          className={`
              pb-[20px] w-full pt-1 px-1 rounded-3xl cursor-pointer transition-all duration-200
              ${isSelected ? `${ColorMap[d.hoverColor]} border-none` : `group border border-gray-500 ${hoverColorMap[d.hoverColor]} hover:border-none`}
            `}
                        >
                          <div
                            className={`
                rounded-3xl p-3 bg-white transition-all duration-200
                ${isSelected ? 'border-none shadow-md' : `border-2 ${d.borderColor} group-hover:border-transparent group-hover:shadow-md`}
              `}
                          >
                            <div className="flex justify-between items-center">
                              <p className="display-xs font-bold">{d.label}</p>
                              <img
                                src={d.imagePath}
                                alt=""
                                className="w-[119px] h-[119px]"
                              />
                            </div>

                            {/* {isSelected ? (
                              <div
                                className={`w-[10%] rounded-full border ${d.checkBorderColor} ${ColorMap[d.hoverColor]}`}
                              >
                                <RiCheckLine size={21} className="text-white" />
                              </div>
                            ) : (
                              <div className="invisible">1</div>
                            )
                            } */}
                          </div>
                        </div>
                      );

                      return (
                        <div key={i} className="w-[50%]">
                          {card}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </Box>
          </Fade>
        </Modal>
        {/* choose survey type modal  */}
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={surveyTypeModal}
          onClose={() => {
            setSurveyTypeModal(false);
          }}
          closeAfterTransition
        >
          <Fade in={surveyTypeModal}>
            <Box
              sx={{
                ...style,
                width: 480,
                boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
              }}
            >
              <div className="px-6 py-5">
                <div className="space-y-5">
                  <div className="text-center">
                    <h1 className="text-[#333] font-[600] text-[18px]">
                      Create New Survey
                    </h1>
                    <p className="text-[13px] text-[#666] mt-1">
                      Choose how you'd like to create your survey
                    </p>
                  </div>

                  {/* AI Option - Clean Card */}
                  <button
                    className="w-full p-4 bg-[#F8F9FF] hover:bg-[#F0F3FF] border border-[#E8EBFF] rounded-lg transition-all text-left flex items-center gap-4 group"
                    onClick={() => {
                      setSurveyTypeModal(false);
                      setAISurveyModal(true);
                    }}
                  >
                    <div className="w-11 h-11 rounded-lg bg-[#0226BE] flex items-center justify-center flex-shrink-0">
                      <svg
                        className="w-5 h-5 text-white"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={1.5}
                          d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z"
                        />
                      </svg>
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2">
                        <h3 className="text-[14px] font-[500] text-[#333]">
                          Create with AI
                        </h3>
                        <span className="px-1.5 py-0.5 text-[9px] font-[600] bg-[#0226BE] text-white rounded">
                          NEW
                        </span>
                      </div>
                      <p className="text-[12px] text-[#666] mt-0.5">
                        Paste your RFP and let AI configure automatically
                      </p>
                    </div>
                    <svg
                      className="w-5 h-5 text-[#999] group-hover:text-[#0226BE] group-hover:translate-x-0.5 transition-all flex-shrink-0"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </button>

                  <div className="flex items-center gap-3">
                    <div className="flex-1 h-px bg-[#E0E0E0]"></div>
                    <span className="text-[11px] text-[#999] font-[500]">
                      OR SELECT MANUALLY
                    </span>
                    <div className="flex-1 h-px bg-[#E0E0E0]"></div>
                  </div>

                  {/* B2C and B2B Options */}
                  <div className="flex items-center gap-3 justify-center">
                    <div
                      className={`py-4 px-3 text-center w-[50%] space-y-2 rounded-lg cursor-pointer transition-all border ${
                        inputData?.setup?.targetAudience == 'B2C'
                          ? 'bg-[#F8F9FF] border-[#0226BE]'
                          : 'bg-white border-[#E0E0E0] hover:border-[#999]'
                      }`}
                      onClick={(e) => {
                        if (inputData?.setup?.targetAudience !== 'B2C') {
                          setInputData((prev) => ({
                            ...prev,
                            setup: {
                              ...prev?.setup,
                              targetAudience: 'B2C',
                            },
                          }));
                        }
                      }}
                    >
                      <div
                        className={`w-10 h-10 mx-auto rounded-lg flex items-center justify-center ${
                          inputData?.setup?.targetAudience == 'B2C'
                            ? 'bg-[#0226BE]'
                            : 'bg-[#F0F0F0]'
                        }`}
                      >
                        <svg
                          className={`w-5 h-5 ${inputData?.setup?.targetAudience == 'B2C' ? 'text-white' : 'text-[#666]'}`}
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={1.5}
                            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                          />
                        </svg>
                      </div>
                      <h3
                        className={`text-[18px] font-[600] ${
                          inputData?.setup?.targetAudience == 'B2C'
                            ? 'text-[#0226BE]'
                            : 'text-[#666]'
                        }`}
                      >
                        B2C
                      </h3>
                      <p className="text-[11px] text-[#888]">Consumer Survey</p>
                    </div>

                    <div
                      className={`py-4 px-3 text-center w-[50%] space-y-2 rounded-lg cursor-pointer transition-all border ${
                        inputData?.setup?.targetAudience == 'B2B'
                          ? 'bg-[#F8F9FF] border-[#0226BE]'
                          : 'bg-white border-[#E0E0E0] hover:border-[#999]'
                      }`}
                      onClick={(e) => {
                        if (inputData?.setup?.targetAudience !== 'B2B') {
                          setInputData((prev) => ({
                            ...prev,
                            setup: {
                              ...prev?.setup,
                              targetAudience: 'B2B',
                            },
                          }));
                        }
                      }}
                    >
                      <div
                        className={`w-10 h-10 mx-auto rounded-lg flex items-center justify-center ${
                          inputData?.setup?.targetAudience == 'B2B'
                            ? 'bg-[#0226BE]'
                            : 'bg-[#F0F0F0]'
                        }`}
                      >
                        <svg
                          className={`w-5 h-5 ${inputData?.setup?.targetAudience == 'B2B' ? 'text-white' : 'text-[#666]'}`}
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={1.5}
                            d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                          />
                        </svg>
                      </div>
                      <h3
                        className={`text-[18px] font-[600] ${
                          inputData?.setup?.targetAudience == 'B2B'
                            ? 'text-[#0226BE]'
                            : 'text-[#666]'
                        }`}
                      >
                        B2B
                      </h3>
                      <p className="text-[11px] text-[#888]">Business Survey</p>
                    </div>
                  </div>

                  <button
                    type="button"
                    onClick={(e) => {
                      handleOpen();
                      setSurveyTypeModal(false);
                    }}
                    className="w-full text-white text-[13px] font-[500] bg-[#0226BE] hover:bg-[#021ea8] rounded-lg py-2.5 transition-colors"
                  >
                    Continue with {inputData?.setup?.targetAudience || 'B2C'}
                  </button>
                </div>
              </div>
            </Box>
          </Fade>
        </Modal>
        {/* qualitative project modal */}
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={qualProjectModal}
          closeAfterTransition
          onClose={handleQualCloseModal}
        >
          <Fade in={qualProjectModal}>
            <Box
              sx={{
                ...style,
                width: 580,
                boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
              }}
            >
              <form
                className="py-8 px-10 space-y-6"
                onSubmit={handleQualProjectSubmit}
              >
                <header className="w-full text-center space-y-1">
                  <h1 className="text-3xl font-medium text-gray-900">
                    Create New Project
                  </h1>
                  <p className="text-gray-600 text-xs">
                    Name and describe your project here
                  </p>
                </header>
                <hr className="border-primary" />
                <div className="space-y-1.5">
                  <p className="text-sm font-medium text-gray-600">
                    Internal Project Title{' '}
                    <span className="text-red-500">*</span>
                  </p>
                  <div className="space-y-1">
                    <input
                      type="text"
                      placeholder="e.g. Smartphone Purchase Behaviour IDI - India"
                      className={`px-3.5 py-2.5 border w-full rounded-md  focus:border-gray-600 placeholder:text-xs text-xs ${qualFormErrors?.internalProjectTitle ? 'border-red-500' : ''}`}
                      required
                      name="internalProjectTitle"
                      minLength={3}
                      maxLength={150}
                      onChange={qualHandleChange}
                      value={qualProjectData?.internalProjectTitle}
                    />
                    {qualFormErrors?.internalProjectTitle && (
                      <p className="text-red-500 text-xs font-[400]">
                        {qualFormErrors?.internalProjectTitle}
                      </p>
                    )}
                  </div>
                  <p className="text-gray-500 text-xs font-[400]">
                    This title is used by your team and Mirats team to identify
                    the project.
                  </p>
                </div>
                <div className="space-y-1.5">
                  <p className="text-sm font-medium text-gray-600">
                    Internal Project Description
                    <span className="text-red-500">*</span>
                  </p>
                  <div>
                    <textarea
                      className={`px-3.5 py-2.5 border w-full rounded-md resize-none placeholder:text-xs text-xs focus:border-gray-600 focus:outline-none ${qualFormErrors?.internalProjectDescription ? 'border-red-500' : ''}`}
                      placeholder="Briefly describe the purpose of this study, target audience, and expected research outcome."
                      rows={5}
                      required
                      maxLength={1000}
                      name="internalProjectDescription"
                      onChange={qualHandleChange}
                      value={qualProjectData?.internalProjectDescription}
                    />
                    {qualFormErrors?.internalProjectDescription && (
                      <p className="text-red-500 text-xs font-[400]">
                        {qualFormErrors?.internalProjectDescription}
                      </p>
                    )}
                  </div>
                  <p className="text-gray-500 text-xs font-[400]">
                    Provide a quick snapshot of the project for your team. Max
                    1000 words.
                  </p>
                </div>
                {qualFormErrors?.projectInfo &&
                  typeof qualFormErrors?.projectInfo === 'string' && (
                    <p className="text-red-500 text-xs font-[400]">
                      {qualFormErrors?.projectInfo}
                    </p>
                  )}
                <hr />
                <div className="w-full flex items-center justify-between">
                  <button
                    className="border border-gray-700 text-gray-700 rounded-lg px-4 py-2 text-sm hover:bg-gray-200 transition-colors hover:font-semibold "
                    type="button"
                    onClick={handleQualCloseModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="appearance-none flex items-center gap-1 text-white bg-primary px-4 py-2 text-sm hover:font-semibold rounded-lg "
                  >
                    Save & Continue <RiArrowRightSLine size={20} />
                  </button>
                </div>
              </form>
            </Box>
          </Fade>
        </Modal>

        {/* AI Survey Modal */}
        <AISurveyModal
          open={aiSurveyModal}
          onClose={() => setAISurveyModal(false)}
          user={user}
          organization={organization}
          onSuccess={() => {
            setAISurveyModal(false);
            handleSurveyStatsRefresh();
          }}
        />

        {/* create modal*/}
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={() => {
            setOpen(false);
            setInputData({
              edit: false,
              setup: {
                targetAudience: 'B2C',
              },
              isInstantSampling: true,
            });
          }}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}
        >
          <Fade in={open}>
            <Box sx={{ ...style }}>
              <div className="w-full flex flex-col bg-white">
                <div className="w-full py-5 px-6 border-b border-gray-200 text-left relative">
                  <h1 className="text-[#0226BE] text-[20px] font-[600]">
                    {inputData?.edit ? 'Edit' : 'Create'} Survey
                  </h1>
                  <p className="text-gray-600 text-[14px] mt-1">
                    {inputData?.edit
                      ? 'Update survey details'
                      : 'Create a new target screener survey'}
                  </p>
                  <button
                    className="absolute top-4 right-4 p-1.5 hover:bg-gray-100 rounded-full cursor-pointer transition-colors"
                    onClick={() => {
                      setOpen(false);
                      setInputData({
                        edit: false,
                        setup: {
                          targetAudience: 'B2C',
                        },
                        isInstantSampling: true,
                      });
                      setSelectRows([]);
                    }}
                  >
                    <RxCross2 size={18} className="text-gray-600" />
                  </button>
                </div>
                <form
                  className="w-full flex flex-col"
                  onSubmit={inputData?.edit ? editSurvey : handleSubmit}
                >
                  <div className="w-full py-6 px-6 flex flex-col gap-5 max-h-[calc(90vh-200px)] overflow-y-auto containerScroll">
                    <div className="flex flex-col gap-2">
                      <label
                        htmlFor="SurveyName"
                        className="text-[#1a1a1a] text-[14px] font-[500]"
                      >
                        Survey Name <Required />
                      </label>
                      <input
                        type="text"
                        name="surveyName"
                        required
                        onChange={handleChange}
                        value={inputData?.surveyName}
                        placeholder="Enter survey name"
                        className="border border-gray-300 rounded-md pl-4 pr-4 h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all text-[#1a1a1a] text-[14px] placeholder:text-gray-400 hover:border-gray-400"
                      />
                    </div>
                    {/* survey group start */}
                    <div className="flex flex-col gap-2">
                      <label
                        htmlFor="SurveyGroup"
                        className="text-[#1a1a1a] text-[14px] font-[500]"
                      >
                        Survey Group
                      </label>
                      <select
                        className="w-full border border-gray-300 rounded-md pl-4 pr-10 h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all text-[#1a1a1a] text-[14px] font-[400] cursor-pointer hover:border-gray-400 appearance-none bg-[url('data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22currentColor%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3e%3cpolyline points=%226 9 12 15 18 9%22%3e%3c/polyline%3e%3c/svg%3e')] bg-[length:18px] bg-[right_10px_center] bg-no-repeat"
                        value={inputData?.surveyGroup || ''}
                        onChange={(e) => {
                          if (inputData?.edit && !inputData?.prevSurveyGroup) {
                            setInputData((prev) => ({
                              ...prev,
                              prevSurveyGroup: inputData?.surveyGroup?._id,
                              surveyGroup: e.target.value,
                            }));
                          } else {
                            setInputData((prev) => ({
                              ...prev,
                              surveyGroup: e.target.value,
                            }));
                          }
                        }}
                      >
                        <option value="">Select Survey Group</option>
                        {allSurveyGroup?.map((d, i) => (
                          <option value={d?._id} key={i}>
                            {d?.groupName}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* survey group end */}
                    <div className="flex flex-col gap-2">
                      <label
                        htmlFor="ProjectManager"
                        className="text-[#1a1a1a] text-[14px] font-[500]"
                      >
                        Project Manager <Required />
                      </label>
                      <select
                        className="w-full border border-gray-300 rounded-md pl-4 pr-10 h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all text-[#1a1a1a] text-[14px] font-[400] cursor-pointer hover:border-gray-400 appearance-none bg-[url('data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22currentColor%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3e%3cpolyline points=%226 9 12 15 18 9%22%3e%3c/polyline%3e%3c/svg%3e')] bg-[length:18px] bg-[right_10px_center] bg-no-repeat"
                        required
                        value={inputData?.peoples?.projectManager || ''}
                        onChange={(e) =>
                          setInputData((prev) => ({
                            ...prev,
                            peoples: {
                              ...prev.peoples,
                              projectManager: [e.target.value],
                            },
                          }))
                        }
                      >
                        <option value="">Select Project Manager</option>
                        {teamMembers?.map((data, key) => (
                          <option key={key} value={data?._id}>
                            {data?.personalDetails?.fullName}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="grid grid-cols-3 gap-4">
                      {/* no of competes */}
                      <div className="flex flex-col gap-2">
                        <label
                          htmlFor="expectedCompletes"
                          className="text-[#1a1a1a] text-[14px] font-[500]"
                        >
                          No. of Completes <Required />
                        </label>
                        <input
                          type="number"
                          placeholder="10"
                          required
                          min="10"
                          value={
                            inputData?.expectedMatrix?.expectedCompletes || ''
                          }
                          onKeyDown={(e) => {
                            if (
                              e.key === 'e' ||
                              e.key === '+' ||
                              e.key === '-'
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            if (e.target.value <= 1000000) {
                              setInputData((prev) => ({
                                ...prev,
                                expectedMatrix: {
                                  ...prev.expectedMatrix,
                                  expectedCompletes: Number(e.target.value),
                                },
                              }));
                            } else {
                              setSnackbar({
                                open: true,
                                msg: 'No of completes should be less than or equal to 1000000',
                                severity: 'error',
                              });
                            }
                          }}
                          className="border border-gray-300 rounded-md pl-4 pr-4 h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all text-[#1a1a1a] text-[14px] placeholder:text-gray-400 hover:border-gray-400"
                        />
                      </div>
                      {/* expected loi */}
                      <div className="flex flex-col gap-2">
                        <label
                          htmlFor="expectedCompletionLOI"
                          className="text-[#1a1a1a] text-[14px] font-[500]"
                        >
                          Expected LOI (mins) <Required />
                        </label>
                        <input
                          type="number"
                          placeholder="15"
                          step="0.01"
                          required
                          min="1"
                          value={
                            inputData?.expectedMatrix?.expectedCompletionLOI ||
                            ''
                          }
                          onKeyDown={(e) => {
                            if (
                              e.key === 'e' ||
                              e.key === '+' ||
                              e.key === '-'
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            if (e.target.value <= 90) {
                              setInputData((prev) => ({
                                ...prev,
                                expectedMatrix: {
                                  ...prev.expectedMatrix,
                                  expectedCompletionLOI: Number(e.target.value),
                                },
                              }));
                            } else {
                              setSnackbar({
                                open: true,
                                msg: 'Expected LOI should be less than or equal to 90 mins',
                                severity: 'error',
                              });
                            }
                          }}
                          className="border border-gray-300 rounded-md pl-4 pr-4 h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all text-[#1a1a1a] text-[14px] placeholder:text-gray-400 hover:border-gray-400"
                        />
                      </div>
                      {/* expected IR */}
                      <div className="flex flex-col gap-2">
                        <label
                          htmlFor="expectedIncidenceRate"
                          className="text-[#1a1a1a] text-[14px] font-[500]"
                        >
                          Expected IR(%) <Required />
                        </label>
                        <input
                          type="number"
                          placeholder="25"
                          step="0.01"
                          required
                          min="1"
                          value={
                            inputData?.expectedMatrix?.expectedIncidenceRate ||
                            ''
                          }
                          onKeyDown={(e) => {
                            if (
                              e.key === 'e' ||
                              e.key === '+' ||
                              e.key === '-'
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            if (e.target.value <= 100) {
                              setInputData((prev) => ({
                                ...prev,
                                expectedMatrix: {
                                  ...prev.expectedMatrix,
                                  expectedIncidenceRate: Number(e.target.value),
                                },
                              }));
                            } else {
                              setSnackbar({
                                open: true,
                                msg: 'Expected IR should be less than or equal to 100 %',
                                severity: 'error',
                              });
                            }
                          }}
                          className="border border-gray-300 rounded-md pl-4 pr-4 h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all text-[#1a1a1a] text-[14px] placeholder:text-gray-400 hover:border-gray-400"
                        />
                      </div>
                    </div>
                    <div className="flex flex-col gap-2">
                      <label
                        htmlFor="Country"
                        className="text-[#1a1a1a] text-[14px] font-[500]"
                      >
                        Country <Required />
                      </label>
                      <SearchableCountrySelect
                        countryData={countryData}
                        value={inputData?.setup?.countryCode}
                        onChange={(selectedOption) => {
                          setInputData((prev) => ({
                            ...prev,
                            setup: {
                              ...prev.setup,
                              country: selectedOption?.label || '',
                              countryCode: selectedOption?.value || '',
                            },
                          }));
                        }}
                        placeholder="Select Country"
                        isRequired={true}
                        height="48px"
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <label
                        htmlFor="surveyCpi"
                        className="text-[#1a1a1a] text-[14px] font-[500]"
                      >
                        Survey CPI (USD) <Required />
                      </label>
                      <input
                        type="number"
                        placeholder={
                          inputData?.setup?.targetAudience === 'B2B'
                            ? '5.00'
                            : '1.00'
                        }
                        step="0.01"
                        min={
                          inputData?.setup?.targetAudience === 'B2B' ? '5' : '1'
                        }
                        required
                        onKeyDown={(e) => {
                          if (e.key === 'e' || e.key === '+' || e.key === '-') {
                            e.preventDefault();
                          }
                        }}
                        value={inputData?.setup?.surveyCpi || ''}
                        onChange={(e) => {
                          setInputData((prev) => ({
                            ...prev,
                            setup: {
                              ...prev.setup,
                              surveyCpi: e.target.value,
                            },
                          }));
                        }}
                        className="border border-gray-300 rounded-md pl-4 pr-4 h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all text-[#1a1a1a] text-[14px] placeholder:text-gray-400 hover:border-gray-400"
                      />
                    </div>
                    {/* Instant Sampling Option */}
                    <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
                      <label className="flex items-start gap-3 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={inputData?.isInstantSampling !== false}
                          onChange={(e) =>
                            setInputData((prev) => ({
                              ...prev,
                              isInstantSampling: e.target.checked,
                            }))
                          }
                          className="w-4 h-4 mt-0.5 cursor-pointer accent-[#0226BE]"
                        />
                        <div className="flex-1">
                          <div className="flex items-center gap-2">
                            <span className="text-[#1a1a1a] text-[14px] font-[600]">
                              Instant Sampling Mode
                            </span>
                            <svg
                              className="w-4 h-4 fill-current text-[#0226BE]"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z" />
                            </svg>
                          </div>
                          <p className="text-gray-600 text-[13px] mt-1">
                            Enable premium survey mode for instant sampling and
                            faster data collection
                          </p>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="w-full flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-200 bg-gray-50">
                    <button
                      type="button"
                      onClick={() => {
                        setOpen(false);
                        setInputData({
                          edit: false,
                          setup: {
                            targetAudience: 'B2C',
                          },
                          isInstantSampling: true,
                        });
                        setSelectRows([]);
                      }}
                      className="px-5 py-2.5 border-2 border-gray-300 rounded-md text-gray-700 text-[14px] font-[500] hover:bg-gray-50 transition-colors"
                    >
                      Cancel
                    </button>
                    {loading ? (
                      <button
                        type="button"
                        disabled
                        className="px-6 py-2.5 bg-[#0226BE] text-white rounded-md text-[14px] font-[500] opacity-75 cursor-not-allowed flex items-center gap-2"
                      >
                        <CircularProgress size={18} className="text-white" />
                        {inputData?.edit ? 'Updating...' : 'Creating...'}
                      </button>
                    ) : inputData?.isInstantSampling === false ? (
                      <a
                        href="https://accounts.mirats.app/register?redirect=https%3A%2F%2Fblaze.mirats.app&eu=U2FsdGVkX19w2z%252BAsMc9z2YFkMyNKG%252FX%252F0f9FUZwTuirEbyC0We%252ByYInXrt3LeM7"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="px-6 py-2.5 bg-[#0226BE] text-white rounded-md text-[14px] font-[500] hover:bg-[#021ea8] transition-colors"
                      >
                        Sign up at Blaze for Managed Services
                      </a>
                    ) : (
                      <button
                        type="submit"
                        className="px-6 py-2.5 bg-[#0226BE] text-white rounded-md text-[14px] font-[500] hover:bg-[#021ea8] transition-colors"
                      >
                        {inputData?.edit ? 'Update Survey' : 'Create Survey'}
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </Box>
          </Fade>
        </Modal>

        {/* DELETE MODAL */}
        <DeleteModal
          open={deleteModal}
          handleClose={handleCloseModal}
          btnText="Archive"
          oparationText="Archive"
          text={
            selectRows?.length
              ? selectRows
                  ?.filter(
                    (d) =>
                      d?.surveyStatus !== 'archived' &&
                      d?.surveyStatus !== 'completed' &&
                      d?.surveyStatus !== 'billed',
                  )
                  ?.map((data) => data?.surveyName)
              : allSurveyStats?.data
                  ?.filter(
                    (d) =>
                      d?.survey?.surveyStatus !== 'archived' &&
                      d?.survey?.surveyStatus !== 'completed' &&
                      d?.survey?.surveyStatus !== 'billed',
                  )
                  ?.map((data) => data?.survey?.surveyName)
          }
          handleClick={(e) => deleteSurveys(e)}
        />
      </div>
    </PageWrapper>
  );
};

export default Survey;
